import { render, staticRenderFns } from "./_import.vue?vue&type=template&id=318e977d&"
import script from "./_import.vue?vue&type=script&lang=js&"
export * from "./_import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports